<template>
  <v-card class="mx-auto text-center" color="green" dark>
    <v-card-text>
      <v-sheet color="rgba(0, 0, 0, .12)">
        <v-sparkline
          :value="values"
          color="rgba(255, 255, 255, .7)"
          height="100"
          padding="18"
          stroke-linecap="round"
          smooth
        >
          <template v-slot:label="item">
            {{ Math.round(item.value) }} zł</template
          >
        </v-sparkline>
      </v-sheet>
    </v-card-text>

    <v-card-text>
      <div class="text-h4 font-weight-thin">
        Wykres kwot z ostatnich zamówień
      </div>
    </v-card-text>

    <v-divider></v-divider>

    <v-card-actions class="justify-center">
      <v-btn block text :to="{ name: 'CMSOrders' }"> Idź do zamówień </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  data: () => ({}),
  props: {
    values: {
      type: Array,
    },
  },
};
</script>